module.exports = __webpack_public_path__ + "static/media/img_head_null.f0744325.svg";